import CargosCliente from "../views/modulos/cargoscliente/List.vue";
const VarRutasCargosCliente=[
    {
        path: '/CargosCliente',
        name: 'cargoscliente',
        component: CargosCliente,
        props: true
    },
];
export default {
    VarRutasCargosCliente,
}